module.exports = __webpack_public_path__ + "static/media/icon-twitter.a1f1bb24.svg";